/**
 * Build the canonical walk detail URL from walk data.
 * Format: /walks/{country}/{city}/{neighborhood}/{slug}
 *
 * @param {object} walk — must have slug; optionally country, city, neighborhood
 * @returns {string} e.g. "/walks/us/los-angeles/santa-monica/beach-walk"
 */
export default function walkUrl(walk) {
  if (!walk) return '/walks';
  const country = walk.country || 'us';
  const city = walk.city || 'los-angeles';
  // Prefer neighborhood, fall back to slugified region, then city slug
  let neighborhood = walk.neighborhood;
  if (!neighborhood || neighborhood === 'explore') {
    neighborhood = walk.region
      ? walk.region.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '')
      : city;
  }
  const slug = walk.slug || '';
  return `/walks/${country}/${city}/${neighborhood}/${slug}`;
}
